import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../../hooks/hooks';
import * as R from 'ramda';
import LogisticQuoteComponent from '../components/logistics-quote.component';
import { quotes } from '../../../../../../../redux/quotes/action';
import { selectQuotesQueryItems } from '../../../../../../../redux/quotes/selector';
import PageLoader from '../../../../../../../components/PageLoader';


const CustomerQuote = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const parmas: any = useParams()
  const quoteQuery = useSelector(selectQuotesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    quoteDetails,
    setQuoteDetails
  ] = useState<any>([])

  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'category_type_Id', headerName: 'category Type Id' },
      { field: 'item_name', headerName: 'Item Name' },
      { field: 'item_description', headerName: 'Item Description' },
      { field: 'quantity', headerName: 'Quantity' },
      { field: 'weight.value', headerName: 'Weight' }
    ]);
  };

  const fetchVehicleById = () => {
    dispatch(quotes.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/query`, entity: 'quotes', jsonData: {

        Records: [
          {
            Context: {},
            Message: {
              Id: parmas?.id
            }
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split('.', field);
    const value = { ...data, [fields[0]]: event }; // inner data update
    setQuoteDetails({ ...quoteDetails, [fields[0]]: value });
  };

  useEffect(
    () => {
      if (parmas?.id > 0) {
        createColumnDefs()
        fetchVehicleById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setQuoteDetails(quoteQuery?.result?.items?.Message)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/customer/logistics/transport/logistics-quotes')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <LogisticQuoteComponent
          handleInnerFormChange={handleInnerFormChange}
          quoteDetails={quoteDetails}
          rowData={quoteDetails?.LogisticsQuoteItems}
          columnDefs={columnDefs}
          back={back}
        />}
    </>
  )

}

export default CustomerQuote;